import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import styles from './Separator.css';

class Separator extends Component {
  static propTypes = {
    theme: PropTypes.shape({
      'border-color-class': PropTypes.string,
    }),
    hasVerticalMargins: PropTypes.bool,
  };

  static defaultProps = {
    theme: {},
    hasVerticalMargins: true,
  };

  render() {
    const className = classnames('separator', {
      '-no-margin': this.props.hasVerticalMargins === false,
    });
    return <div className={this.props.theme['border-color-class']} styleName={className} />;
  }
}

export default CSSModules(Separator, styles, {
  errorWhenNotFound: false,
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./application/js/components/Separator.js